module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_qr_card_pp) ? _c('div', {
    staticClass: "qr_card_popup"
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": _vm.hideCardQr
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qr-pp-close",
    on: {
      "click": _vm.hideCardQr
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "qr-pp-heading"
  }, [_vm._v("Персональный QR код")]), _vm._v(" "), _c('div', {
    staticClass: "qr-pp-wp"
  }, [_c('qrcode', {
    attrs: {
      "value": _vm.getUserCardID,
      "options": {
        size: 400
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "qr-pp-info"
  }, [_vm._v("Показывайте код на кассе при покупке товаров, чтбы начислять баллы за покупки")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2adb2a88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/card-numer-qr-code.vue
// module id = 292
// module chunks = 1